const BIO_ONLY_HOSTS = new Set(["zulekha.co.ke"]);

export function normalizeHost(hostname) {
  return String(hostname || "")
    .replace(/^www\./i, "")
    .toLowerCase();
}

export function isBioOnlyDomain(hostname = window.location.hostname) {
  return BIO_ONLY_HOSTS.has(normalizeHost(hostname));
}
